import { z } from 'zod';
/** Sent by clients over `/ws` (design §9). The first message must be `auth`. */
export const ClientMessage = z.discriminatedUnion('type', [
    z.object({ type: z.literal('auth'), token: z.string().min(1).max(4096) }),
    z.object({ type: z.literal('ping') }),
    z.object({ type: z.literal('presence.set'), status: z.enum(['online', 'idle', 'dnd']) }),
    /**
     * Whether the app is in front (a focused window, the phone app open). Phones get push only while
     * no app of that person is; unlike presence it is not shown to anyone. Assumed in front until said.
     */
    z.object({ type: z.literal('focus.set'), focused: z.boolean() }),
    /**
     * Sent by a client in a voice room after toggling mic, camera or screen share. LiveKit sends
     * no webhook for mute changes, so the server re-reads the room from LiveKit.
     */
    z.object({ type: z.literal('voice.refresh'), channelId: z.uuid() }),
    /** Sent every few seconds while the user types; others show "yazıyor…" for a short while. */
    z.object({ type: z.literal('typing'), channelId: z.uuid() }),
]);
/** WebSocket close codes NovaChat uses (4000–4999 are free for applications). */
export const CloseCode = {
    AuthTimeout: 4000,
    Unauthorized: 4001,
    /** Session revoked or permission removed: sign in again. */
    SessionEnded: 4003,
    BadMessage: 4004,
};
//# sourceMappingURL=realtime.js.map